import React, { useState } from 'react';
import { Box, Drawer, IconButton } from '@mui/material';
import { Outlet } from 'react-router-dom';
import Sidebar from '../../components/MyAccount/Sidebar/Sidebar';
import { HiOutlineMenuAlt2 } from "react-icons/hi";
import { useLanguage } from '../../context/LanguageContext/LanguageContext';

const MyAccount = () => {
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const { translations, direction, language } = useLanguage();
  const t = translations;
  const toggleDrawer = () => {
    setIsDrawerOpen(!isDrawerOpen);
  };

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: {
          xs: 'column', // Stack vertically on extra small screens
          sm: 'column', // Stack vertically on small screens
          md: 'row',    // Horizontal layout on medium screens and above
        },
        minHeight: '80vh',
        backgroundColor: '#FAFAFA',
      }}
    >
      {/* Drawer for Small Screens */}
      <Box
        sx={{
          display: { xs: 'block', md: 'none' }, // Show menu button only on small screens
          position: 'absolute',
          top: '16%',
          left: direction === 'rtl' ? '8px' : '',
          right:direction === 'ltr' ? '8px' : ''
        }}
      >
        <IconButton onClick={toggleDrawer} >
          <HiOutlineMenuAlt2 style={{ fontSize: "32px", color: "#12538B", zIndex: 12000 }} />
        </IconButton>
      </Box>

      <Drawer
        anchor={direction === 'rtl' ? 'right' : 'left'}
        open={isDrawerOpen}
        onClose={toggleDrawer}
        sx={{
          display: { xs: 'block', md: 'none' },
        }}
      >
        <Sidebar t={t} language={language}/>
      </Drawer>

      {/* Sidebar for Medium and Larger Screens */}
      <Box
        sx={{
          display: { xs: 'none', md: 'block' },
          backgroundColor: "#fff"
        }}
      >
        <Sidebar t={t} language={language}/>
      </Box>

      {/* Main Content */}
      <Box
        sx={{
          flex: 1,
          padding: {
            xs: '10px', // Reduced padding for extra small and small screens
            sm: '15px',
            md: '20px', // Standard padding for medium screens and above
          },
        }}
      >
        <Outlet t={t} direction={direction} />
      </Box>
    </Box>
  );
};

export default MyAccount;
